import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import { SUPERGET, SUPERPOST } from '../../Services/AxiosService';
import { CustomStringify } from "../../Helpers/CustomStringify";

export const fetchDataBarRate = createAsyncThunk(
  "BarcodeRateSetting/fetchDataBarRate",
  async (cmpdetail, { rejectWithValue }) => {

    try {
      const result = await SUPERGET(`/settings/barcode/${cmpdetail?.key}`);
      return result;
    } catch (error) {
      return rejectWithValue(error?.response?.data?.message || error?.message)
    }
  }
);

const BarcodeRateSettingSlice = createSlice({
  name: "BarcodeRateSetting",
  initialState: {
    cmpdetail: {},
    status: "idle",
    error: null,
  },
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(fetchDataBarRate.pending, (state) => {
        state.status = "loading";
      })
      .addCase(fetchDataBarRate.fulfilled, (state, action) => {
        state.status = "succeeded";
        state.cmpdetail = action?.payload?.data ? { ...action?.payload?.data, barcode_rate_encrption_codes: action?.payload?.data?.barcode_rate_encrption_codes || [] } : {};
      })
      .addCase(fetchDataBarRate.rejected, (state, action) => {
        state.status = "failed";
        state.error = action.payload;
      });
  },
});

export default BarcodeRateSettingSlice.reducer;
